export default __webpack_public_path__ + "static/media/left-arrow.bb288448.svg";